import $ from 'jquery';

const displayAppropriate = (equipeName) => {
    const allEmploye = document.querySelectorAll('.employe');
    const employeDeEquipe = document
        .querySelectorAll(`[data-equipe="${equipeName}"]`);

    if (employeDeEquipe.length !== 0) {
        allEmploye.forEach((employe) => {
            employe.setAttribute('style', 'display: none;');
        });
        employeDeEquipe.forEach((employe) => {
            employe.setAttribute('style', 'display: block;');
        });
    } else {
        allEmploye.forEach((employe) => {
            employe.setAttribute('style', 'display: block;');
        });
    }
};

const uncheckEquipes = (boxChecked, choix) => {
    choix.forEach((box) => {
        if (box.id !== boxChecked.id) {
            // eslint-disable-next-line no-param-reassign
            box.checked = false;
        }
    });
};

const equipeSelect = () => {
    const choix = document.getElementsByName('filtre');

    choix.forEach((equipeBox) => {
        equipeBox.addEventListener('click', () => {
            uncheckEquipes(equipeBox, choix);

            const equipeName = equipeBox.id.slice(7);
            const displayWhat = equipeBox.checked ? equipeName : '';
            displayAppropriate(displayWhat);
        });
    });
};

if ($('.employes-filtre')[0]) {
    $('document').ready(equipeSelect);
}
